import { render, staticRenderFns } from "./RecommendationModal.vue?vue&type=template&id=b9da9264"
import script from "./RecommendationModal.vue?vue&type=script&lang=js"
export * from "./RecommendationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports